import React from 'react';
import { Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import POSButton from 'PointOfSale/modules/common/component/Button';
import { MEAL_TYPES } from 'PointOfSale/modules/common/constants';

const MenuButtonList = props => {
  const { currentSelectedMenu, handleOnClickMenuItem } = props;

  return (
    <Grid.Row>
      <Grid.Column className="meals-type">
        {MEAL_TYPES.map(menu => {
          return (
            <POSButton
              label={menu.label}
              key={menu.key}
              clickHandler={() => {
                handleOnClickMenuItem(menu);
              }}
              selected={currentSelectedMenu === menu.label}
            />
          );
        })}
      </Grid.Column>
    </Grid.Row>
  );
};

MenuButtonList.propTypes = {
  clickHandler: PropTypes.func,
  routes: PropTypes.object,
};

MenuButtonList.defaultProps = {
  menuItems: PropTypes.array,
  clickHandler: PropTypes.func,
};
export default MenuButtonList;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/mealTypes/component/MenuButtonList.js